import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=e508a77c&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=e508a77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e508a77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e508a77c')) {
      api.createRecord('e508a77c', component.options)
    } else {
      api.reload('e508a77c', component.options)
    }
    module.hot.accept("./TopNav.vue?vue&type=template&id=e508a77c&scoped=true&", function () {
      api.rerender('e508a77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TopNav.vue"
export default component.exports